import { RETAILER_CONFIG_MAP, type RetailerKey, isOtherRetailerRegion } from '@vizit/constants';
import { AmazonIcon, UsFlagCircleIcon, WalmartCircleIcon } from '@vizit/icons';
import type { ComponentType } from 'react';

type RetailerIconComponent = ComponentType<{ size?: number }>;

/**
 * Maps RetailerConfig.baseIcon string values to the actual icon components.
 * Add new entries here when a new retailer is added to RETAILER_CONFIG_MAP.
 */
export const RETAILER_ICONS: Record<string, RetailerIconComponent> = {
  AmazonIcon,
  WalmartCircleIcon,
};

interface GetRetailerIconOptions {
  /** Whether the Other retailer is shown, with a US flag icon */
  showOther: boolean;
}

/**
 * The icon of a retailer region, or null when it has none (an unknown region, or Other while it is hidden).
 */
export function getRetailerIcon(
  retailerRegionId: string | null | undefined,
  options: GetRetailerIconOptions,
): RetailerIconComponent | null {
  if (isOtherRetailerRegion(retailerRegionId)) return options.showOther ? UsFlagCircleIcon : null;

  const baseIcon = RETAILER_CONFIG_MAP[retailerRegionId as RetailerKey]?.baseIcon;
  return (baseIcon && RETAILER_ICONS[baseIcon]) || null;
}

export type { GetRetailerIconOptions, RetailerIconComponent };
